// extracted by mini-css-extract-plugin
export default {"mixedCards":"MixedCards_mixedCards__i1FZ4","mixedCards__small":"MixedCards_mixedCards__small__dosn9"};